import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as movementsSelectors, actions as movementsActions } from 'ducks/customerEnquiry/movements';
import { fetch } from 'api/customerEnquiry/movements';
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters';
import { selectors as customerSelector } from 'ducks/customer';


const params = new URLSearchParams(location.search)

export const mapStateToProps = state => ({
  gridName: 'CustomerEnquiryMovements',
  columnDefs: movementsSelectors.columns(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  gridOptions: movementsSelectors.gridOptions(state),
  filterRow: movementsSelectors.filterRow(state),
  selectedFilters: movementsSelectors.selectedFilters(state),
  appliedFilters: movementsSelectors.filterRow(state) && filterSelectors.getFilters(state, movementsSelectors.filterRow(state).formName),
  reqParams: (customerSelector.selected(state) || params.get('CustomerId'))
    &&
    {
      CustomerId: (customerSelector.selected(state) && customerSelector.selected(state).CustomerId) || params.get('CustomerId')
    },
  apiMethod: fetch
})

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: movementsActions.setSelected,
  applyFilters: filterActions.applyFilters
}
